import { useEffect } from "react";
import { useLocation } from "react-router";

import { capitalizedPathName } from "../../../helpers/string";
import useTheme from "../../../helpers/useTheme";

const NonAuthLayout = ({ children }) => {
  const { enterprise = {} } = useTheme();
  const location = useLocation();

  useEffect(() => {
    const title = capitalizedPathName(location.pathname);
    document.title = title + ` | ${enterprise?.name || ""}`;
  }, [location, enterprise]);

  return <>{children}</>;
};

export default NonAuthLayout;
